import { trpc, TrpcOutputs } from '../config/trpc';
import { API } from '../utils/apiTypes';

type Quote = TrpcOutputs['getQuote'] | API.QuoteWithTotalCost;

export const useCanChangeFlight = (quote: Quote | null | undefined) => {
  const isBooked = !!quote?.request?.booked_quote_variant;
  const requestId = quote?.request_id;
  const providerId = quote?.provider_id;
  const isApiGenerated = !!quote?.is_api_generated;

  const { data } = trpc.getAlternativeFlights.useQuery(
    {
      request_id: requestId ?? 0,
      provider_id: providerId ?? '',
      limit: 2,
      offset: 0,
    },
    {
      enabled: Boolean(requestId && providerId && isApiGenerated && !isBooked),
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );

  const hasFlightsToSelect = (data?.total_count ?? 0) > 1;

  return !isBooked && isApiGenerated && hasFlightsToSelect;
};
